var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUsIconRectenggle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 77,
    viewBox: "0 0 74 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_173518",
    "data-name": "\\uADF8\\uB8F9 173518",
    transform: "translate(-4602 178) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_153059",
    "data-name": "\\uC0AC\\uAC01\\uD615 153059",
    width: 23,
    height: 24,
    transform: "translate(129 4602)",
    fill: "#f3e3a1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153060",
    "data-name": "\\uC0AC\\uAC01\\uD615 153060",
    transform: "translate(152 4626)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153058",
    "data-name": "\\uC0AC\\uAC01\\uD615 153058",
    transform: "translate(101 4650)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsIconRectenggle3);
export default __webpack_public_path__ + "static/media/contact_us_icon_rectenggle3.40a842cfa48c89cc6dae7ebe7ea13d28.svg";
export { ForwardRef as ReactComponent };